import React, { useState, useEffect } from "react";
import { BASE_URL } from "./Constants";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Papa from "papaparse";
import Select from "react-select";
import sampleTemplate from "./templates/sample_upload_type.csv";

const UploadQuestion = () => {

  const [csvFile, setCsvFile] = useState(null);

  /* ========= Department ========= */
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);

  /* ========= Question Type ========= */
  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedQuestionType, setSelectedQuestionType] = useState(null);
  const [questionList, setQuestionList] = useState([]);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [insertedCount, setInsertedCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  /* ========= PAGINATION ========= */
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentQuestions = questionList.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(
    questionList.length / itemsPerPage
  );

  const fetchQuestions = async () => {
    try {
      setLoadingQuestions(true);

      const response = await fetch(`${BASE_URL}question`);
      const data = await response.json();

      if (data.question) {
        setQuestionList(data.question);
      }
    } catch (error) {
      console.error("Question fetch error:", error);
    } finally {
      setLoadingQuestions(false);
    }
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchDepartments();
    fetchQuestionTypes();
    fetchQuestions();
  }, []);

  /* ===== Fetch Departments ===== */
  const fetchDepartments = async () => {
    try {
      const response = await fetch(`${BASE_URL}dept`);
      const data = await response.json();

      if (data.departments) {
        const options = data.departments.map((d) => ({
          value: d.dept_name,
          label: d.dept_name,
        }));

        setDepartments(options);
      }
    } catch (error) {
      console.error("Department fetch error:", error);
    }
  };

  /* ===== Fetch Question Types ===== */
  const fetchQuestionTypes = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}prepare_question_type_list`
      );

      const data = await response.json();

      if (data.data) {
        const options = data.data.map((q) => ({
          value: q.id,              // question_type_id
          label: q.question_type,   // display text
        }));

        setQuestionTypes(options);
      }
    } catch (error) {
      console.error("Question type fetch error:", error);
    }
  };

  /* ================= CSV UPLOAD ================= */
  const handleCSVUpload = () => {

    if (!selectedDept) {
      alert("Please select department");
      return;
    }

    if (!selectedQuestionType) {
      alert("Please select question type");
      return;
    }

    if (!csvFile) {
      alert("Please select CSV file");
      return;
    }

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        try {
          const token = localStorage.getItem("authToken");

          const response = await fetch(
            `${BASE_URL}upload_question_csv`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                department: selectedDept.value,
                question_type_id: selectedQuestionType.value,
                question_type: selectedQuestionType.label,
                data: results.data,
              }),
            }
          );

          const res = await response.json();

          if (res.status) {

            const result = res.data;

            setDuplicateList(result.duplicates || []);
            setInsertedCount(result.inserted_count || 0);

            if (result.inserted_count > 0) {
              alert(`✅ ${result.inserted_count} questions uploaded`);
              fetchQuestions(); // reload table
            }

            if (result.duplicate_count > 0) {
              alert(`⚠ ${result.duplicate_count} duplicate questions skipped`);
            }

            setCsvFile(null);
            setSelectedDept(null);
            setSelectedQuestionType(null);
          } else {
            alert("Upload Failed");
          }
        } catch (error) {
          console.error("Upload Error:", error);
        }
      },
    });
  };



  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">

            <div className="card shadow-sm border-0">
              <div className="card-body">

                <h4 className="fw-bold mb-4">
                  Upload Viva Questions (CSV)
                </h4>

                <div className="row mb-4 align-items-end">

                  {/* Sample Download */}
                  <div className="col-md-3">
                    <label className="fw-semibold mb-2 d-block">
                      Sample Template
                    </label>
                    <a
                      href={sampleTemplate}
                      download="sample_questions_template.csv"
                      className="btn btn-outline-success w-100"
                    >
                      ⬇ Download
                    </a>
                  </div>

                  {/* Department */}
                  <div className="col-md-4">
                    <label className="fw-semibold mb-2">
                      Department
                    </label>

                    <Select
                      options={departments}
                      value={selectedDept}
                      onChange={setSelectedDept}
                      placeholder="Select Department..."
                      isSearchable
                    />
                  </div>

                  {/* Question Type */}
                  <div className="col-md-5">
                    <label className="fw-semibold mb-2">
                      Question Type
                    </label>

                    <Select
                      options={questionTypes}
                      value={selectedQuestionType}
                      onChange={setSelectedQuestionType}
                      placeholder="Select Question Type..."
                      isSearchable
                    />
                  </div>

                </div>

                {/* ===== CSV Upload ===== */}
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="file"
                      accept=".csv"
                      className="form-control"
                      onChange={(e) =>
                        setCsvFile(e.target.files[0])
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={handleCSVUpload}
                    >
                      Upload CSV
                    </button>
                  </div>
                </div>

              </div>
            </div>
            {(duplicateList.length > 0 || insertedCount > 0) && (
              <div className="card shadow-sm border-0 mt-4">
                <div className="card-body">

                  {insertedCount > 0 && (
                    <div className="alert alert-success">
                      ✅ {insertedCount} questions uploaded successfully
                    </div>
                  )}

                  {duplicateList.length > 0 && (
                    <>
                      <h6 className="text-danger fw-bold">
                        Duplicate Questions Skipped
                      </h6>

                      <ul className="list-group mt-2">
                        {duplicateList.map((q, index) => (
                          <li key={index} className="list-group-item">
                            {q}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}

                </div>
              </div>
            )}
            <div className="card shadow-sm border-0 mt-4">
              <div className="card-body">

                <h5 className="fw-bold mb-3">Questions List</h5>

                {loadingQuestions ? (
                  <p>Loading questions...</p>
                ) : (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-hover"
                      style={{ tableLayout: "fixed", width: "100%" }}
                    >
                      <thead className="table-dark">
                        <tr>
                          <th style={{ width: "70px" }}>ID</th>
                          <th style={{ width: "150px" }}>Department</th>
                          <th style={{ width: "180px" }}>Type</th>
                          <th style={{ width: "300px" }}>Question</th>
                          <th style={{ width: "250px" }}>Answer</th>
                          <th style={{ width: "120px" }}>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {questionList.length > 0 ? (
                          currentQuestions.map((item) => (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.dept}</td>
                              <td>{item.question_type_name}</td>
                              <td
                                style={{
                                  maxWidth: "300px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere"
                                }}
                              >
                                {item.question}
                              </td>
                              <td
                                style={{
                                  maxWidth: "250px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere"
                                }}
                              >
                                {item.answer}
                              </td>
                              <td>
                                <span
                                  className={`badge ${item.status === "A"
                                      ? "bg-success"
                                      : "bg-danger"
                                    }`}
                                >
                                  {item.status === "A"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Questions Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {/* ===== Pagination ===== */}
                    <div className="d-flex justify-content-between align-items-center mt-3">

                      {/* Items Per Page */}
                      <div>
                        <select
                          className="form-select"
                          style={{ width: "120px" }}
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>

                      {/* Page Controls */}
                      <div>
                        <button
                          className="btn btn-outline-primary me-2"
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Prev
                        </button>

                        <span className="fw-bold">
                          Page {currentPage} of {totalPages || 1}
                        </span>

                        <button
                          className="btn btn-outline-primary ms-2"
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </div>

                    </div>
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadQuestion;